// neo_cogym — 코드위즈 연결 상태 UI (W6)
// shim 의 디바이스 상태(connecting/ready/running/...)를 배지로 표시 + 연결/해제 버튼.

const LABEL: Record<string, string> = {
  disconnected: "연결 안 됨",
  connecting: "연결 중…",
  ready: "연결됨",
  running: "실행 중",
  stopped: "정지",
};

const COLOR: Record<string, string> = {
  disconnected: "#9aa0a6",
  connecting: "#f9ab00",
  ready: "#34a853",
  running: "#1a73e8",
  stopped: "#9aa0a6",
};

export function ConnectionStatus({
  status,
  webSerial,
  ready,
  onConnect,
  onDisconnect,
}: {
  status: string;
  webSerial: boolean;
  ready: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}) {
  const connected = status !== "disconnected";
  return (
    <div className="conn-status" role="status">
      <span className="conn-dot" style={{ background: COLOR[status] ?? "#9aa0a6" }} />
      <span className="conn-label">코드위즈: {LABEL[status] ?? status}</span>
      <span className="conn-mode">{webSerial ? "USB" : "Wi-Fi 릴레이"}</span>
      {connected ? (
        <button onClick={onDisconnect}>해제</button>
      ) : (
        <button onClick={onConnect} disabled={!ready}>연결</button>
      )}
    </div>
  );
}
